import React, { useEffect, useState } from 'react'
import { FormViewType } from '../Tickets';
import { darkModeBackgroud } from '../../../../utils/constants';
import { DataSelectType } from '../../../../models/DataSelectType';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';
import { TicketImageInterface } from '../../../../models/TicketModule/TicketImage';
import TicketCard from './TicketCard';
import FeedbackModal from '../TicketModal/FeedbackModal';
import PhotoModalComp from '../TicketModal/PhotoModalComp';
import ToastMessage from '../../../../common/ToastMessage';
import CardHeader from '../../Assets/Components/Header/CardHeader';
import FilterTicComponent from '../Components/Filter/FilterTicComponent';
import useTickets from '../../../../store/ReactQueries/tickets/useTicket';

interface CardViewFormProps {
    page: number;
    pageSize: number;
    selectedIds: string[];
    formView: FormViewType;
    showFilters: boolean;
    filterData: DataSelectType[] | undefined;
    setPage: React.Dispatch<React.SetStateAction<number>>;
    setPageSize: React.Dispatch<React.SetStateAction<number>>;
    setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
    setFormView: React.Dispatch<React.SetStateAction<FormViewType>>;
    setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;
    setFilterData: React.Dispatch<React.SetStateAction<DataSelectType[] | undefined>>;
}

export const CardViewForm: React.FC<CardViewFormProps> = ({
    page, pageSize, selectedIds, formView, showFilters, filterData,
    setPage, setPageSize, setSelectedIds, setFormView, setShowFilters, setFilterData,
}) => {
    const { darkMode } = useDarkModeStore();
    const { data: tickets, error } = useTickets(page, pageSize, filterData);

    const [openFeedbackModal, setOpenFeedbackModal] = useState<{ isOpen: boolean, ticketId: string }>({ isOpen: false, ticketId: '' });
    const [openPhotoModal, setOpenPhotoModal] = useState<{ isOpen: boolean, photos: TicketImageInterface[] }>({ isOpen: false, photos: [] });

    const handleClosePhotos = () => setOpenPhotoModal({ isOpen: false, photos: [] });
    const handleCloseFeedback = () => setOpenFeedbackModal({ isOpen: false, ticketId: '' });

    useEffect(() => {
        if (error) ToastMessage.Failed(error.message);
    }, [error])

    return (
        <div className='mb-4'>
            <CardHeader
                page={page}
                module="Tickets"
                pageSize={pageSize}
                formView={formView}
                selectedIds={selectedIds}
                showFilters={showFilters}
                arrayLength={tickets?.length ?? 0}
                setPage={setPage}
                setPageSize={setPageSize}
                setFormView={setFormView}
                setShowFilters={setShowFilters}
                setSelectedIds={setSelectedIds}
            />
            <div className={`d-flex flex-row transition-wrapper ${!showFilters && 'gap-0'}`}>
                <div className={`content ${showFilters ? "shrink" : ""}`}>
                    {
                        tickets?.map(ticket =>
                            <TicketCard
                                key={ticket.id}
                                page={page}
                                ticket={ticket}
                                pageSize={pageSize}
                                selectedIds={selectedIds}
                                setSelectedIds={setSelectedIds}
                                setOpenPhotoModal={setOpenPhotoModal}
                                setOpenFeedbackModal={setOpenFeedbackModal}
                            />)
                    }
                </div>
                <div
                    className={`filter-section ${showFilters ? "expand" : ""}`}
                    style={{ border: showFilters ? '1px solid rgba(224, 224, 224, 1)' : 'none', background: darkMode ? darkModeBackgroud : 'white' }}
                >
                    {
                        showFilters
                        && <FilterTicComponent
                            page={page}
                            pageSize={pageSize}
                            filterData={filterData}
                            showFilters={showFilters}
                            setPage={setPage}
                            setFilterData={setFilterData}
                        />
                    }
                </div>
            </div>
            {
                openPhotoModal.isOpen
                && openPhotoModal.photos.length > 0
                && <PhotoModalComp
                    selectedIndex={0}
                    open={openPhotoModal.isOpen}
                    photos={openPhotoModal.photos}
                    handleClose={handleClosePhotos}
                />
            }
            {
                openFeedbackModal.isOpen
                && <FeedbackModal
                    open={openFeedbackModal.isOpen}
                    ticketId={openFeedbackModal.ticketId}
                    handleClose={handleCloseFeedback}
                />
            }
        </div>
    );
}
export default CardViewForm